import { render, staticRenderFns } from "./FormularioCadastroProdutos.vue?vue&type=template&id=2c7e8bd8&"
import script from "./FormularioCadastroProdutos.vue?vue&type=script&lang=js&"
export * from "./FormularioCadastroProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports